import {stringify} from 'qs'
import {format} from 'utils'
import request from 'company-management/utils/request'
import api from '../apis/account'

export async function accounts(params) {
    return request(`${api.accounts.url}${stringify(params, {addQueryPrefix: true})}`)
}

export async function create(payload) {
    return request(api.create.url, {
        method: api.create.type,
        body: payload.body,
    })
}

export async function update(payload) {
    return request(format(api.update.url, {id: payload.id}), {
        method: api.update.type,
        body: payload.body,
    })
}
